import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer style={{
      background: '#0F172A',
      color: '#94A3B8',
      padding: '64px 0 36px',
      marginTop: 0,
    }}>
      <div className="container">
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: 40,
          marginBottom: 48,
        }}>
          <div>
            <div style={{
              display: 'flex', alignItems: 'center', gap: 10,
              fontFamily: "'Baloo 2', sans-serif", fontWeight: 800,
              fontSize: '1.5rem', color: 'white', marginBottom: 12,
            }}>
              <span style={{
                width: 40, height: 40, borderRadius: 10,
                background: 'linear-gradient(180deg, #6EC6F5 0%, #7C3AED 100%)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                overflow: 'hidden',
              }}>
                <img src="/guessup-icon-fg.png" alt="" width="36" height="36" />
              </span>
              GuessUp
            </div>
            <p style={{ color: '#94A3B8', fontSize: '0.95rem', lineHeight: 1.7, maxWidth: 320 }}>
              The fastest 1v1 number-guessing duel. Built for friends who love to compete.
            </p>
          </div>

          <div>
            <h4 style={{ color: 'white', fontFamily: "'Baloo 2', sans-serif", fontWeight: 700, marginBottom: 14, fontSize: '1rem' }}>
              Product
            </h4>
            <FooterLink href="/#features">Features</FooterLink>
            <FooterLink href="/#how-it-works">How it works</FooterLink>
            <FooterLink href="/#screenshots">Screenshots</FooterLink>
            <FooterLink href="/#download">Download</FooterLink>
          </div>

          <div>
            <h4 style={{ color: 'white', fontFamily: "'Baloo 2', sans-serif", fontWeight: 700, marginBottom: 14, fontSize: '1rem' }}>
              Legal
            </h4>
            <FooterRouterLink to="/privacy-policy">Privacy Policy</FooterRouterLink>
            <FooterRouterLink to="/terms-and-conditions">Terms & Conditions</FooterRouterLink>
            <FooterRouterLink to="/contact">Contact</FooterRouterLink>
          </div>

          <div>
            <h4 style={{ color: 'white', fontFamily: "'Baloo 2', sans-serif", fontWeight: 700, marginBottom: 14, fontSize: '1rem' }}>
              Get in touch
            </h4>
            <a href="mailto:webmalik3@gmail.com" style={{ color: '#A78BFA', fontWeight: 600, fontSize: '0.95rem', display: 'block', marginBottom: 10 }}>
              webmalik3@gmail.com
            </a>
            <p style={{ color: '#64748B', fontSize: '0.85rem', margin: 0 }}>
              We respond within 24–48 hours.
            </p>
          </div>
        </div>

        <div style={{
          paddingTop: 24,
          borderTop: '1px solid rgba(148, 163, 184, 0.18)',
          display: 'flex',
          flexWrap: 'wrap',
          gap: 16,
          justifyContent: 'space-between',
          alignItems: 'center',
          fontSize: '0.85rem',
          color: '#64748B',
        }}>
          <span>© {new Date().getFullYear()} GuessUp. All rights reserved.</span>
          <span>Made for the friends you love to outsmart.</span>
        </div>
      </div>
    </footer>
  );
}

function FooterLink({ href, children }) {
  return (
    <a href={href} style={{
      display: 'block',
      color: '#94A3B8',
      fontSize: '0.92rem',
      padding: '6px 0',
    }}>
      {children}
    </a>
  );
}

function FooterRouterLink({ to, children }) {
  return (
    <Link to={to} style={{
      display: 'block',
      color: '#94A3B8',
      fontSize: '0.92rem',
      padding: '6px 0',
    }}>
      {children}
    </Link>
  );
}
